/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type LandingPageEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const landingPageEntryPoint: EntryPoint<LandingPageEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<LandingPageEntryPointComponent>(
			/* webpackChunkName: "async-assets-landing-page-entrypoint" */ './index.tsx',
		),
		getPreloadProps: () => ({}),
	});
